$(document).on('submit', '.search-form', function (e) {
    e.preventDefault();
    // var searchInput = $('#searchBar').val();
    var searchInput = $(this).find("input[name=search]").val();
    var url = "/search/" + encodeURIComponent(searchInput);
    // console.log(url);
    window.location.href = url;
});